import React from 'react';
import { ImageViewer } from 'antd-mobile';

interface PhotoViewerProps {
    photoUrl: string | null | undefined;
    onClose: () => void;
}

const PhotoViewer: React.FC<PhotoViewerProps> = ({ photoUrl, onClose }) => {
    if (!photoUrl) return null;

    return (
        <ImageViewer
            image={photoUrl}
            visible={true}
            onClose={onClose}
            renderFooter={() => null}
        />
    );
};

export default PhotoViewer; 